module.exports = __webpack_public_path__ + "img/ic_settings.40dff82e.svg";